import { render, staticRenderFns } from "./ServiceL3.vue?vue&type=template&id=066d20b9&scoped=true"
import script from "./ServiceL3.vue?vue&type=script&lang=ts"
export * from "./ServiceL3.vue?vue&type=script&lang=ts"
import style0 from "./ServiceL3.vue?vue&type=style&index=0&id=066d20b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066d20b9",
  null
  
)

export default component.exports